// Parse DeFi "D" lettermark SVG — v56.2 lines 12-21
interface LogoMarkProps {
  size?: number
  color?: string
}

export function LogoMark({ size = 40, color = '#000000' }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="420 510 2060 2230"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g transform="translate(0,3000) scale(0.1,-0.1)" fill={color} stroke="none">
        <path d="M8910 17455 l0 -6415 -282 -1 c-156 -1 -292 -4 -304 -7 -11 -4 -717 -689 -1568 -1522 l-1548 -1515 1851 -3 1851 -2 0 -2175 c0 -1196 2 -2175 5 -2175 2 0 68 13 147 30 617 128 1153 364 1608 706 500 377 881 865 1106 1419 l49 120 3 7343 2 7343 2188 -4 c2342 -4 2256 -2 2595 -52 1332 -199 2525 -957 3274 -2080 407 -611 669 -1307 762 -2025 124 -953 -31 -1894 -450 -2745 -672 -1365 -1946 -2325 -3449 -2599 -338 -62 -580 -76 -1297 -76 l-572 0 -1344 -1473 c-738 -809 -1360 -1491 -1381 -1515 l-39 -43 2204 4 c2379 4 2272 2 2729 57 1436 175 2787 738 3890 1621 518 414 984 907 1365 1440 709 994 1199 2230 1399 3529 70 450 91 725 91 1160 0 364 -10 524 -51 890 -196 1752 -819 3231 -1854 4404 -1332 1510 -3380 2513 -5565 2726 -115 11 -277 25 -360 32 -109 8 -1095 12 -3602 15 l-3453 4 0 -6416z" />
      </g>
    </svg>
  )
}
